import { Col } from "react-bootstrap";
import checkIcon from "../assets/login/check.svg";
import shieldCheckIcon from "../assets/login/shield-check.svg";
import teletraceLogoWhite from "../assets/login/teletrace-logo-white.png";

const BRAND = "#064260";
const FEATURES = [
	"GPS-verified community visit records",
	"Electronic encounter forms with audit trails",
	"EHR visit validation",
	"HIPAA Compliant",
];

const AuthBrandPanel = () => (
	<Col
		className="d-flex flex-column justify-content-between text-white auth-page__brand"
		lg={4}
		md={5}
		style={{ backgroundColor: BRAND, padding: "48px 40px" }}
		xs={12}>
		<div>
			<img
				alt="TeleTrace"
				src={teletraceLogoWhite}
				style={{ display: "block", height: "41px", objectFit: "contain", width: "142px" }}
			/>
		</div>

		<div className="d-flex flex-column" style={{ gap: "32px" }}>
			<h1 className="mb-0 text-white" style={{ fontSize: "32px", fontWeight: 600, lineHeight: 1.2 }}>
				Behavioral Health
				<br />
				Visit Verification, Simplified
			</h1>
			<ul className="list-unstyled mb-0 d-flex flex-column" style={{ gap: "16px" }}>
				{FEATURES.map((feature) => (
					<li className="d-flex align-items-start" key={feature} style={{ gap: "12px" }}>
						<img
							alt=""
							src={checkIcon}
							style={{ flexShrink: 0, height: "16px", marginTop: "2px", width: "16px" }}
						/>
						<span style={{ fontSize: "15px", lineHeight: 1.4 }}>{feature}</span>
					</li>
				))}
			</ul>
		</div>

		<div className="d-flex flex-column" style={{ gap: "12px" }}>
			<hr
				className="m-0 w-100"
				style={{ backgroundColor: "rgba(255,255,255,0.08)", border: 0, height: "1px", opacity: 1 }}
			/>
			<div className="d-flex align-items-center" style={{ gap: "8px" }}>
				<img alt="" src={shieldCheckIcon} style={{ flexShrink: 0, height: "14px", width: "14px" }} />
				<p className="mb-0" style={{ color: "rgba(226,232,240,0.38)", fontSize: "12px", fontWeight: 500 }}>
					HIPAA Compliant · SOC2 Type II Certified · ISO 27001
				</p>
			</div>
		</div>
	</Col>
);

export default AuthBrandPanel;
